import api from './axiosInstance';

export async function getUsersByRole(roleId, searchText = '', signal) {
  try {
    const params = {};
    if (searchText && searchText.trim()) {
      params.search = searchText.trim();
    }

    const response = await api.get(`/Clients/users/by-role/${roleId}`, {
      params,
      signal,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users by role:', error);
    throw error;
  }
}
